import { gql } from '@apollo/client';

export const addCredGql = gql`
  mutation addCredOnContract(
    $contractId: String!
    $credential: CredentialInput!
  ) {
    addCredOnContract(contractId: $contractId, credential: $credential) {
      _id
    }
  }
`;
